import React ,{Component} from 'react'; 
import { Redirect  } from 'react-router-dom';
import Serverurl from './Apiurl';
import axios from 'axios'; 
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';  
import { makeStyles } from '@material-ui/core/styles';  
import Paper from '@material-ui/core/Paper';  
import Table from '@material-ui/core/Table'; 
import TableSortLabel from '@material-ui/core/TableSortLabel'; 
import TableBody from '@material-ui/core/TableBody';  
import TableCell from '@material-ui/core/TableCell';  
import TableContainer from '@material-ui/core/TableContainer';  
import TableHead from '@material-ui/core/TableHead';  
import TablePagination from '@material-ui/core/TablePagination';  
import TextField from '@material-ui/core/TextField';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';

import Select from '@material-ui/core/Select';

import { Page, Section } from 'react-page-layout';
import './styles.css'; 
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import editimg from './images/edit.png';
import deleteimg from './images/delete.png';

const headCells = [


  { id: '',  label: '' },
  
  { id: 'pl_title', numeric: false, label: 'Title' },
  { id: 'pl_type', numeric: false, label: 'Type' },
  
  
  
  ]
  
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Place extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect:false,
      placedata:[],plid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:100,rowsPaging:[],
	  order:'desc' ,orderBy:'pl_id',title:'',type:'',search:'',

	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	componentDidUpdate() {
		
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}
	componentDidMount() {  
	
	
	if(localStorage.getItem("TNuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'Login'
          })
		  }
	
	document.title = "Top Note - Place";
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
 
} 




myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	  axios.get(Serverurl+'ajaxplace.php?action=list&pl_title='+this.state.title+'&pl_type='+this.state.type+'&Sorting='+this.state.orderby+''+this.state.order+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  placedata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:[],
			  
		    });
			
				let copy=[100,200,300,400,500];
			/*let cnt=this.state.totaldata;
			let page=5;
			 cnt=Number(cnt)/Number(page);
	
		
			for (var key=0;key<cnt;key++) { 
			
				let val=(Number(key)*5)+5;
				
			 copy.push( val)
			}*/
			
	  
	  this.setState({rowsPaging:copy  });
	 
     }
	 else{
		   this.setState({placedata:[],totaldata:0});
	 }
  //alert(this.state.prevdis_icon);
    });
}

handleSubmit= (event) => {
    
    event.preventDefault();
	
	let title = this.state.title;
	let type = this.state.type;
	
	this.apicall(this.state.page,this.state.rowsPerPage);
	
	
} 

handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  
   
     
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
   handleChangeRowsPerPage = event => {  
   
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)
    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
  }; 


       PlaceDelete(plid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('pl_id',plid)
	 formData.append('userid',localStorage.getItem("TNuserid"))
	
	 axios.post(Serverurl+"ajaxplace.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
     Placeaddbox(val){
        this.setState({ plid: val });  
  
         setTimeout(() => this.refs.AddPlacebox.handleClickOpen(),500);

      }

render() {
	
if (this.state.redirect === true) {
      return <Redirect to={this.state.pagename} />
    }	
	

  return (
  <Page layout="public">
<Section slot="header"> Place
</Section>

<Section slot="backbutton"> 

  <a onClick={()=>{this.Placeaddbox(0)}} className="pointer" >New</a>

</Section>
 


 <Section slot="main">
 
  <React.Fragment>
  <div className="serachcont">
  <div className="serachcnt">
  <ul>
  <li>
  
  <p><TextField
            
            variant="outlined"
            fullWidth
			value={this.state.title}
            id="title"            
            name="title" onChange={this.myChangeHandler}
			placeholder="Title"
			
          />
		  </p></li>
		  
		  <li>
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.type}
          onChange={this.myChangeHandler}
        name='type'
         id='type'
		 
		  InputLabelProps={{
			  
            shrink: true,
          }}
        >
		   
          <option value={0}>All</option>
          <option value={1}>Godown</option>
          <option value={2}>Production Unit</option>
		  
          </Select>
      </FormControl>
		  	   </p>
  
		    </li>
			
			
		 </ul>
  </div> 
	<div className="submitbtns">		
			<p className="searchbutton"><Button
            type="submit"
            fullWidth
            variant="contained" 
            color="primary"
            className="submitbtn"
			onClick={this.handleSubmit}
			
          >
            Search
          </Button>	</p>  
		

  </div>
<div className="clear"></div>
  </div>
		
		
     
<div className="ordtbl">
<AddPlacebox ref="AddPlacebox" id={this.state.plid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}> 


 
  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.placedata.length}
            />
                      <TableBody>
                     {(this.state.placedata).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
<TableCell align="left">
<div className="actionbtns">

<ul><li>
<div className="editbtn">
<img src={editimg} onClick={()=>{this.Placeaddbox(item.pl_id)}} /> 


 </div> </li>
 
 
 
  &nbsp;  &nbsp;
<li>
<div className="delbtn">
 <img src={deleteimg} onClick={()=>{this.PlaceDelete(item.pl_id)}} />
 

 </div></li>
 </ul>
 </div>
 
 </TableCell>


<TableCell>{item.pl_title}</TableCell>
<TableCell>{item.type}</TableCell>

 </TableRow>

        </React.Fragment>	
				);
					})}
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={this.state.rowsPaging}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />    
  </Paper>
 </div>   

 </React.Fragment> 

 </Section>
</Page>
 
  );
}
}


export  class  AddPlacebox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,title:'',type:'',pl_id:0,
		   errormessage:'',erropen:false,
      
	  }
      
  }
  
  Placegetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxplace.php?action=list&pl_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      pl_id:resp.data[0].pl_id,
	  title: resp.data[0].pl_title,	  
      type: resp.data[0].pl_type,
      	  
	  
    
    });
	//alert(this.state.prevca_icon);
//alert(this.state.)
  }
  
});
	  
  }else{
	 this.setState({  
	 title:'',
	 
	type:'',
	  
	  
	 pl_id:0
	  }); 
 }
  
    }

   
handleClickOpen = (e) => {
 
  this.setState({ open:!this.state.open, title:'',type:'',
  errormessage:'',erropen:false,
   
	  });
		this.Placegetdata();


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  
  	if(nam==="phone" )
  {if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  }
  else{
  this.setState({[nam]: val});
  }

}



handleClose = (e) => {

 
 let title=this.state.title;
 let type=this.state.type;
 let unit=this.state.unit;
 
 
 if(title==="")
{
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

 
if(type==="")
{
	
	this.setState({errormessage:"Please Select Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}





   var formData = new FormData();
  
  
   if(this.state.pl_id===0)
	  {
		  formData.append('pl_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('pl_id',this.state.pl_id)
		
          }
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		
		
		formData.append('pl_title',title)
		formData.append('pl_type',type)
		
		formData.append('userid',localStorage.getItem("TNuserid"))
		  
		axios.post(Serverurl+"ajaxplace.php", formData, {
        }).then(res => {
			
			
    if(res.data == -1)
	{
		
		this.setState({errormessage:"Place with the same name already exist",erropen:true,open:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
		
	}
            this.props.updateDonenew();
    
        });
  
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 


render (){

return(
<React.Fragment>

    <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Place</DialogTitle>
      <DialogContent>
	   
	   	
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	
	
	  	
  	<p>Title <span className="validationtxt">*</span> 
	<TextField name="title" 
	variant="outlined"
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 InputProps={{  maxlength: 150,  }}
			  //autofocus="true"
			  ref={this.usernameInput}
                          /></p>
						  
			
 
	<p>Type <span className="validationtxt">*</span></p>
	<p> <FormControl  className="stadrp">
       
        <Select variant="outlined"
        native
         value={this.state.type}
          onChange={this.myChangeHandler}
        name='type'
         id='type'
		 
		  InputLabelProps={{
			  
            shrink: true,
          }}
        >
		   
          <option value={0}>Select</option>
          <option value={1}>Godown</option>
          <option value={2}>Production Unit</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   
			   
			    
			 
						    </DialogContent>
      <DialogActions>
	  <div className="actionbtns">

<ul><li>
<div className="delbtn">
	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> </li>
 
 &nbsp;  &nbsp;
<li>
<div className="editbtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div></li>
 </ul>
 </div>
      </DialogActions>
    </Dialog>
</React.Fragment>

) }
 
} 
  